








import { Component, Vue } from "vue-property-decorator";
import RevisarReservaChapuzon from "@/components/Formularios/Chapuzon2026/RevisarChapuzon2026.vue";

@Component({
  components: {
    RevisarReservaChapuzon
  }
})
export default class RevisarReservaChapuzonView extends Vue {}
